module.exports = __webpack_public_path__ + "baace85b06307ae9282acaba1902db29.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/outfit-cowboy-s.png
// module id = 1898
// module chunks = 0